import { Namespace } from '_core/utils/ssr';

export const projectConfig = {
  i18nNamespaces: ['common', 'home', 'quotes', 'project', 'briefing', 'stories', 'about'] as Namespace,
};
